import { buildQueryPartWrite, hasPartSelection } from "../shared/queryPartPayload";
import { legacyVehicleModelId } from "../shared/customerVehiclesV1Model";
import { SKIP_SUPPLIERS_REASON } from "../../constants/workflowActions";
export const emptyCreateQueryForm = actorId => ({ vehicle_id: null, urgency: 2, assigned_to: actorId, remarks: "", parts: [], images: [] });
export function buildCreateQueryPayload({ customer, actorId, createForm, action, allImages, channelSelection }) {
      const validParts = createForm.parts.filter(hasPartSelection).map(buildQueryPartWrite);
      const payload = {
        customer_id: customer.customer_id,
        created_by: actorId,
        status: action === "skip" ? "waiting_for_price" : "draft",
        ...(action === "skip" && { reason: SKIP_SUPPLIERS_REASON }),
        ...(createForm.vehicle_id != null && { vehicle_id: createForm.vehicle_id }),
        ...(createForm.urgency != null && { urgency: createForm.urgency }),
        ...(createForm.assigned_to != null && { assigned_to: createForm.assigned_to }),
        ...(createForm.remarks?.trim() && { remarks: createForm.remarks.trim() }),
        ...(validParts.length > 0 && { parts: validParts }),
        ...(allImages.length > 0 && { images: allImages }),
        communication_channel_key: channelSelection.communication_channel_key,
        set_as_customer_default: channelSelection.set_as_customer_default,
      };

  return payload;
}
export function buildCreatedQueryCard({ customer, createForm, vehicles, agentOptions, communicationChannels, channelSelection, res, allImages, createdAt }) {
      // Inject card directly into the kanban board without a refetch
      const selectedVehicle = vehicles.find(v => v.id === createForm.vehicle_id) ?? null;
      const assignedAgent = agentOptions.find(a => a.id === createForm.assigned_to);
      const newCard = {
        id: res.data?.task_id,
        query_id: res.data?.query_id,
        status: res.data?.status ?? "draft",
        urgency: createForm.urgency,
        created_at: createdAt,
        assigned_user: assignedAgent ? { name: assignedAgent.fullName } : null,
        vehicle: selectedVehicle ? {
          id: selectedVehicle.id,
          model_id: legacyVehicleModelId(selectedVehicle),
          model_family_id: selectedVehicle.model_family_id ?? null,
          model_family_name_snapshot: selectedVehicle.model_family_name_snapshot ?? null,
          brand_name: selectedVehicle.brand_name || selectedVehicle.brand_label || selectedVehicle.brand || "",
          model_name: selectedVehicle.model_name || selectedVehicle.model_label || selectedVehicle.model || "",
          year: selectedVehicle.year || null,
        } : null,
        customer: {
          customer_name: customer.customer_real_name || customer.customer_name || null,
          customer_mobile: customer.customer_mobile || null,
        },
        query_parts: res.data?.query_parts || [],
        images: res.data?.images ?? allImages,
        remarks: res.data?.remarks ?? createForm.remarks ?? "",
        has_after_sales: false,
        customer_communication_channel: res.data?.customer_communication_channel || {
          ...(communicationChannels.find(item => item.key === channelSelection.communication_channel_key) || {}),
          compatibility_fallback: false,
        },
      };

  return newCard;
}
